// extracted by mini-css-extract-plugin
export default {"root":"AddMachineModal_root__Bw2T2","placeHolderShimmer":"AddMachineModal_placeHolderShimmer__cgefp"};